<template>
  <div class="box15">
    <pageTitle
      title="就业薪资高"
      text="博学谷学生多领域真项目实操，相当于累积1-3年工作经验"
    />

    <div class="content-box" @scroll="handleScroll">
      <div class="content" ref="content">
        <div class="content-top">
          <div class="name">姓名</div>
          <div class="work">学前岗位</div>
          <div class="oldSalay">学前薪资</div>
          <div class="newSalay">就业薪资</div>
          <div class="company">入职公司</div>
          <div class="sex">性别</div>
          <div class="age">年龄</div>
          <div class="major">大学专业</div>
          <div class="education">学历</div>
          <div class="day">工作年限</div>
        </div>

        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="name">{{ item.name }}</div>
          <div class="work">{{ item.work }}</div>
          <div class="oldSalay">{{ item.oldSalary }}</div>
          <div class="newSalay">{{ item.newSalay }}</div>
          <div class="company">{{ item.company }}</div>
          <div class="sex">{{ item.sex }}</div>
          <div class="age">{{ item.age }}</div>
          <div class="major">{{ item.major }}</div>
          <div class="education">{{ item.education }}</div>
          <div class="day">{{ item.day }}</div>
        </div>

        <!-- <div class="left-box" v-if="showList">
          <div class="name">姓名</div>
          <div class="name">郝同学</div>
          <div class="name">宗同学</div>
          <div class="name">马同学</div>
          <div class="name">温同学</div>
          <div class="name">刘同学</div>
          <div class="name">王同学</div>
        </div> -->
      </div>
    </div>

    <!-- <div class="scorll-box">
      <div class="scorll-block" :style="styleVar"></div>
    </div> -->

    <div class="tip">*数据来源：博学谷就业中心人工智能学科就业数据</div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      list: [
        {
          name: "郝同学",
          sex: "男 ",
          age: "25",
          major: "计算机",
          education: "硕士",
          work: "无",
          day: "0",
          oldSalary: "0",
          newSalay: "18000",
          company: "北京**服务有限公司",
        },
        {
          name: "宗同学",
          sex: "男",
          age: "28",
          major: "计算机",
          education: "本科",
          work: "副校长",
          day: "2",
          oldSalary: "8000",
          newSalay: "18500",
          company: "**信息技术有限公司",
        },
        {
          name: "马同学",
          sex: "男",
          age: "31",
          major: "土木工程",
          education: " 硕士",
          work: "计划运营",
          day: "4",
          oldSalary: "22000",
          newSalay: " 24916",
          company: "安徽**科技有限公司",
        },
        {
          name: " 温同学 ",
          sex: "男",
          age: "26",
          major: "计算机",
          education: "本科",
          work: "JAVA开发",
          day: "1",
          oldSalary: "9000",
          newSalay: "19000",
          company: "北京**科技有限公司",
        },
        {
          name: "刘同学",
          sex: "男",
          age: "23",
          major: "生物工程",
          education: "本科",
          work: "无",
          day: "0",
          oldSalary: "0",
          newSalay: "15500",
          company: "上海**数科技有限公司",
        },
        {
          name: "王同学",
          sex: "男",
          age: "33",
          major: "电子科技",
          education: "本科",
          work: "测试认证",
          day: "12",
          oldSalary: "30000",
          newSalay: "41667",
          company: "保密",
        },
      ],
      scroll: 0,
      // showList: false,
    };
  },
  computed: {
    styleVar() {
      return {
        "--box-left": this.scroll + "px",
      };
    },
  },
  mounted() {},
  methods: {
    handleScroll() {
      // let space = this.$refs.content.getBoundingClientRect().left;
      // if (space <= 0) {
      //   this.showList = true;
      // } else {
      //   this.showList = false;
      // }

      let dom = this.$refs.content.getBoundingClientRect();
      let left = Math.abs(parseInt(dom.x)) / 30;
      if (left >= 1) {
        this.scroll = left;
      } else {
        this.scroll = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box15 {
  position: relative;
  padding: 80px 0px 88px;
  width: 100%;
  background: url("../../../assets/coursePage/ai/box15-bg.png") no-repeat;
  background-size: cover;
  overflow: hidden;

  .left-box {
    position: absolute;
    top: 240px;
    left: 0px;
    // background: #fff;
    // border-radius: 24px;
    box-shadow: 8px 0px 16px 0px rgba(64, 128, 255, 0.06);
    div {
      width: 100%;
      height: 97px;
      line-height: 96px;
      text-align: center;
      border-radius: 24px 24px 0px 0px;
      background: #fff;
      text-align: center;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      border-bottom: 2px solid rgba(232, 243, 255, 0.8);
      box-sizing: border-box;
      &:first-child {
        background: linear-gradient(180deg, #ceecff 0%, #f4faff 100%);
        font-size: 24px;
        font-family: PingFangSC-Medium;
        color: #1d2129;
        font-weight: 500;
        border-bottom: none;
      }
      &:last-child {
        border-bottom: none;
      }
    }
  }

  .scorll-box {
    position: absolute;
    left: 50%;
    bottom: 158px;
    transform: translate(-50%, 0px);
    width: 40px;
    height: 6px;
    background: rgba(46, 165, 252, 0.16);
    border-radius: 3px;
    .scorll-block {
      position: absolute;
      left: var(--box-left);
      width: 20px;
      height: 6px;
      background: #2ea5fc;
      border-radius: 3px;
    }
  }

  .content-box {
    width: 100%;
    padding: 0px 32px;
    padding-bottom: 22px;
    overflow-x: auto;
    box-sizing: border-box;
  }
  .content-box::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }

  .content {
    margin-top: 48px;
    width: 1380px;
    // height: 672px;
    background: #ffffff;
    box-shadow: 0px 8px 24px 0px rgba(64, 128, 255, 0.12);
    border-radius: 24px;
    overflow: hidden;

    .sex {
      width: 96px;
    }
    .age {
      width: 96px;
    }

    .major {
      width: 152px;
    }

    .education {
      width: 96px;
    }

    .day {
      width: 128px;
    }

    .name {
      width: 120px;
    }

    .work {
      width: 144px;
    }

    .oldSalay {
      width: 144px;
    }
    .newSalay {
      width: 144px;
    }
    .company {
      width: 244px;
    }

    .content-top {
      display: flex;
      width: 100%;
      height: 96px;
      line-height: 96px;
      text-align: center;
      border-radius: 24px 24px 0px 0px;
      background: linear-gradient(180deg, #ceecff 0%, #f4faff 100%);
      font-size: 24px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: #1d2129;
    }

    .item {
      display: flex;
      width: 100%;
      height: 96px;
      line-height: 96px;
      text-align: center;
      border-radius: 24px 24px 0px 0px;
      background: #fff;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      border-bottom: 2px solid rgba(232, 243, 255, 0.8);

      .newSalay {
        color: #2ea5fc;
      }
    }
  }

  .tip {
    margin-top: 28px;
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: center;
    color: #b9c8d9;
    line-height: 36px;
  }
}
</style>
